// @generated by protoc-gen-es v1.9.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/offer/v1/offer.proto (package no.jotta.openapi.offer.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
import { Storage } from "../../storage_pb.js";
import { Money, RecurringSubscriptionInterval } from "../../subscription/payment.v2_pb.js";
import { UserSeats } from "../../userseats_pb.js";
import { Country } from "../../country_pb.js";
import { Language } from "../../language_pb.js";
/**
 * @generated from message no.jotta.openapi.offer.v1.Offer
 */
export class Offer extends Message {
    /**
     * @generated from field: string product_code = 1;
     */
    productCode = "";
    /**
     * @generated from field: string product_name_localized = 2;
     */
    productNameLocalized = "";
    /**
     * @generated from field: no.jotta.openapi.offer.v1.Offer.ProductScope product_scope = 10;
     */
    productScope = Offer_ProductScope.UNKNOWN_SCOPE;
    /**
     * @generated from field: no.jotta.openapi.offer.v1.Offer.Payment yearly = 3;
     */
    yearly;
    /**
     * @generated from field: no.jotta.openapi.offer.v1.Offer.Payment monthly = 4;
     */
    monthly;
    /**
     * @generated from field: no.jotta.openapi.Storage base_storage = 9;
     */
    baseStorage;
    /**
     * @generated from field: no.jotta.openapi.Storage total_storage = 5;
     */
    totalStorage;
    /**
     * @generated from field: optional string debug_message = 7;
     */
    debugMessage;
    /**
     * @generated from field: bool extra_storage_available = 8;
     */
    extraStorageAvailable = false;
    /**
     * @generated from field: bool extra_seats_available = 16;
     */
    extraSeatsAvailable = false;
    /**
     * @generated from field: optional uint32 minimum_extra_storage_tb = 14;
     */
    minimumExtraStorageTb;
    /**
     * @generated from field: optional uint32 minimum_extra_seats = 17;
     */
    minimumExtraSeats;
    /**
     * @generated from field: string product_highlight_localized = 11;
     */
    productHighlightLocalized = "";
    /**
     * @generated from field: repeated no.jotta.openapi.offer.v1.Offer.ProductFeature product_features = 15;
     */
    productFeatures = [];
    /**
     * @generated from field: optional string checkout_notice_localized = 13;
     */
    checkoutNoticeLocalized;
    /**
     * @generated from oneof no.jotta.openapi.offer.v1.Offer.voucher_code_status
     */
    voucherCodeStatus = { case: undefined };
    /**
     * @generated from oneof no.jotta.openapi.offer.v1.Offer.status
     */
    status = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.offer.v1.Offer";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "product_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "product_name_localized", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 10, name: "product_scope", kind: "enum", T: proto3.getEnumType(Offer_ProductScope) },
        { no: 3, name: "yearly", kind: "message", T: Offer_Payment },
        { no: 4, name: "monthly", kind: "message", T: Offer_Payment },
        { no: 9, name: "base_storage", kind: "message", T: Storage },
        { no: 5, name: "total_storage", kind: "message", T: Storage },
        { no: 7, name: "debug_message", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 8, name: "extra_storage_available", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 16, name: "extra_seats_available", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 14, name: "minimum_extra_storage_tb", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
        { no: 17, name: "minimum_extra_seats", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
        { no: 11, name: "product_highlight_localized", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 15, name: "product_features", kind: "message", T: Offer_ProductFeature, repeated: true },
        { no: 13, name: "checkout_notice_localized", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
        { no: 20, name: "valid_coupon", kind: "message", T: Offer_ValidCoupon, oneof: "voucher_code_status" },
        { no: 21, name: "valid_voucher", kind: "message", T: Offer_ValidVoucher, oneof: "voucher_code_status" },
        { no: 22, name: "invalid_code", kind: "message", T: Offer_InvalidCode, oneof: "voucher_code_status" },
        { no: 23, name: "coupon_possible", kind: "message", T: Offer_CouponPossible, oneof: "voucher_code_status" },
        { no: 100, name: "recommended", kind: "message", T: Offer_Recommended, oneof: "status" },
        { no: 101, name: "valid", kind: "message", T: Offer_Valid, oneof: "status" },
        { no: 102, name: "invalid", kind: "message", T: Offer_Invalid, oneof: "status" },
        { no: 103, name: "storage_exceeded", kind: "message", T: Offer_StorageExceeded, oneof: "status" },
        { no: 108, name: "users_exceeded", kind: "message", T: Offer_UsersExceeded, oneof: "status" },
        { no: 104, name: "current_subscription", kind: "message", T: Offer_CurrentSubscription, oneof: "status" },
        { no: 107, name: "business_user_not_permitted", kind: "message", T: Offer_BusinessUserNotPermitted, oneof: "status" },
    ]);
    static fromBinary(bytes, options) {
        return new Offer().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Offer().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Offer().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Offer, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.offer.v1.Offer.ProductScope
 */
export var Offer_ProductScope;
(function (Offer_ProductScope) {
    /**
     * @generated from enum value: UNKNOWN_SCOPE = 0;
     */
    Offer_ProductScope[Offer_ProductScope["UNKNOWN_SCOPE"] = 0] = "UNKNOWN_SCOPE";
    /**
     * @generated from enum value: PERSONAL = 1;
     */
    Offer_ProductScope[Offer_ProductScope["PERSONAL"] = 1] = "PERSONAL";
    /**
     * @generated from enum value: HOME = 2;
     */
    Offer_ProductScope[Offer_ProductScope["HOME"] = 2] = "HOME";
    /**
     * @generated from enum value: BUSINESS = 3;
     */
    Offer_ProductScope[Offer_ProductScope["BUSINESS"] = 3] = "BUSINESS";
})(Offer_ProductScope || (Offer_ProductScope = {}));
// Retrieve enum metadata with: proto3.getEnumType(Offer_ProductScope)
proto3.util.setEnumType(Offer_ProductScope, "no.jotta.openapi.offer.v1.Offer.ProductScope", [
    { no: 0, name: "UNKNOWN_SCOPE" },
    { no: 1, name: "PERSONAL" },
    { no: 2, name: "HOME" },
    { no: 3, name: "BUSINESS" },
]);
/**
 * @generated from message no.jotta.openapi.offer.v1.Offer.Payment
 */
export class Offer_Payment extends Message {
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.Money base_price = 1;
     */
    basePrice;
    /**
     * @generated from field: repeated no.jotta.openapi.offer.v1.Offer.Payment.Modifier modifiers = 2;
     */
    modifiers = [];
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.Money billed_now = 3;
     */
    billedNow;
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.Money recurring_price = 4;
     */
    recurringPrice;
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.Money vat = 5;
     */
    vat;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.offer.v1.Offer.Payment";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "base_price", kind: "message", T: Money },
        { no: 2, name: "modifiers", kind: "message", T: Offer_Payment_Modifier, repeated: true },
        { no: 3, name: "billed_now", kind: "message", T: Money },
        { no: 4, name: "recurring_price", kind: "message", T: Money },
        { no: 5, name: "vat", kind: "message", T: Money },
    ]);
    static fromBinary(bytes, options) {
        return new Offer_Payment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Offer_Payment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Offer_Payment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Offer_Payment, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.offer.v1.Offer.Payment.Modifier
 */
export class Offer_Payment_Modifier extends Message {
    /**
     * @generated from field: no.jotta.openapi.subscription.v2.Money amount = 1;
     */
    amount;
    /**
     * @generated from field: string description_localized = 2;
     */
    descriptionLocalized = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.offer.v1.Offer.Payment.Modifier";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "amount", kind: "message", T: Money },
        { no: 2, name: "description_localized", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new Offer_Payment_Modifier().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Offer_Payment_Modifier().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Offer_Payment_Modifier().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Offer_Payment_Modifier, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.offer.v1.Offer.ProductFeature
 */
export class Offer_ProductFeature extends Message {
    /**
     * @generated from field: string label_localized = 1;
     */
    labelLocalized = "";
    /**
     * @generated from field: no.jotta.openapi.offer.v1.Offer.ProductFeature.Type type = 2;
     */
    type = Offer_ProductFeature_Type.UNKNOWN_PRODUCT_FEATURE;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.offer.v1.Offer.ProductFeature";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "label_localized", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(Offer_ProductFeature_Type) },
    ]);
    static fromBinary(bytes, options) {
        return new Offer_ProductFeature().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Offer_ProductFeature().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Offer_ProductFeature().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Offer_ProductFeature, a, b);
    }
}
/**
 * @generated from enum no.jotta.openapi.offer.v1.Offer.ProductFeature.Type
 */
export var Offer_ProductFeature_Type;
(function (Offer_ProductFeature_Type) {
    /**
     * @generated from enum value: UNKNOWN_PRODUCT_FEATURE = 0;
     */
    Offer_ProductFeature_Type[Offer_ProductFeature_Type["UNKNOWN_PRODUCT_FEATURE"] = 0] = "UNKNOWN_PRODUCT_FEATURE";
    /**
     * @generated from enum value: STORAGE = 1;
     */
    Offer_ProductFeature_Type[Offer_ProductFeature_Type["STORAGE"] = 1] = "STORAGE";
    /**
     * @generated from enum value: USER_COUNT = 2;
     */
    Offer_ProductFeature_Type[Offer_ProductFeature_Type["USER_COUNT"] = 2] = "USER_COUNT";
    /**
     * @generated from enum value: DISCLAIMER = 3;
     */
    Offer_ProductFeature_Type[Offer_ProductFeature_Type["DISCLAIMER"] = 3] = "DISCLAIMER";
    /**
     * @generated from enum value: COMMERCIAL_LICENSE = 4;
     */
    Offer_ProductFeature_Type[Offer_ProductFeature_Type["COMMERCIAL_LICENSE"] = 4] = "COMMERCIAL_LICENSE";
    /**
     * @generated from enum value: OTHER = 5;
     */
    Offer_ProductFeature_Type[Offer_ProductFeature_Type["OTHER"] = 5] = "OTHER";
})(Offer_ProductFeature_Type || (Offer_ProductFeature_Type = {}));
// Retrieve enum metadata with: proto3.getEnumType(Offer_ProductFeature_Type)
proto3.util.setEnumType(Offer_ProductFeature_Type, "no.jotta.openapi.offer.v1.Offer.ProductFeature.Type", [
    { no: 0, name: "UNKNOWN_PRODUCT_FEATURE" },
    { no: 1, name: "STORAGE" },
    { no: 2, name: "USER_COUNT" },
    { no: 3, name: "DISCLAIMER" },
    { no: 4, name: "COMMERCIAL_LICENSE" },
    { no: 5, name: "OTHER" },
]);
/**
 * @generated from message no.jotta.openapi.offer.v1.Offer.InvalidCode
 */
export class Offer_InvalidCode extends Message {
    /**
     * @generated from field: string localized_message = 1;
     */
    localizedMessage = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.offer.v1.Offer.InvalidCode";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "localized_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new Offer_InvalidCode().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Offer_InvalidCode().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Offer_InvalidCode().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Offer_InvalidCode, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.offer.v1.Offer.ValidCoupon
 */
export class Offer_ValidCoupon extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.subscription.v2.RecurringSubscriptionInterval valid_for_intervals = 1;
     */
    validForIntervals = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.offer.v1.Offer.ValidCoupon";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "valid_for_intervals", kind: "enum", T: proto3.getEnumType(RecurringSubscriptionInterval), repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new Offer_ValidCoupon().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Offer_ValidCoupon().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Offer_ValidCoupon().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Offer_ValidCoupon, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.offer.v1.Offer.ValidVoucher
 */
export class Offer_ValidVoucher extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.offer.v1.Offer.ValidVoucher";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new Offer_ValidVoucher().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Offer_ValidVoucher().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Offer_ValidVoucher().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Offer_ValidVoucher, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.offer.v1.Offer.CouponPossible
 */
export class Offer_CouponPossible extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.offer.v1.Offer.CouponPossible";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new Offer_CouponPossible().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Offer_CouponPossible().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Offer_CouponPossible().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Offer_CouponPossible, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.offer.v1.Offer.Recommended
 */
export class Offer_Recommended extends Message {
    /**
     * index of priority, e.g. 0 is 1st recommendation, 1 is 2nd recommendation etc.
     *
     * @generated from field: int32 priority_idx = 1;
     */
    priorityIdx = 0;
    /**
     * @generated from field: string title_localized = 2;
     */
    titleLocalized = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.offer.v1.Offer.Recommended";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "priority_idx", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
        { no: 2, name: "title_localized", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new Offer_Recommended().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Offer_Recommended().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Offer_Recommended().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Offer_Recommended, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.offer.v1.Offer.Valid
 */
export class Offer_Valid extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.offer.v1.Offer.Valid";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new Offer_Valid().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Offer_Valid().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Offer_Valid().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Offer_Valid, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.offer.v1.Offer.Invalid
 */
export class Offer_Invalid extends Message {
    /**
     * @generated from field: string error = 1;
     */
    error = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.offer.v1.Offer.Invalid";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new Offer_Invalid().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Offer_Invalid().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Offer_Invalid().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Offer_Invalid, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.offer.v1.Offer.StorageExceeded
 */
export class Offer_StorageExceeded extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.offer.v1.Offer.StorageExceeded";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new Offer_StorageExceeded().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Offer_StorageExceeded().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Offer_StorageExceeded().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Offer_StorageExceeded, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.offer.v1.Offer.UsersExceeded
 */
export class Offer_UsersExceeded extends Message {
    /**
     * @generated from field: no.jotta.openapi.UserSeats current_users = 1;
     */
    currentUsers;
    /**
     * @generated from field: no.jotta.openapi.UserSeats allowed_users = 2;
     */
    allowedUsers;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.offer.v1.Offer.UsersExceeded";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "current_users", kind: "message", T: UserSeats },
        { no: 2, name: "allowed_users", kind: "message", T: UserSeats },
    ]);
    static fromBinary(bytes, options) {
        return new Offer_UsersExceeded().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Offer_UsersExceeded().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Offer_UsersExceeded().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Offer_UsersExceeded, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.offer.v1.Offer.CurrentSubscription
 */
export class Offer_CurrentSubscription extends Message {
    /**
     * @generated from field: no.jotta.openapi.UserSeats current_users = 1;
     */
    currentUsers;
    /**
     * @generated from field: no.jotta.openapi.UserSeats allowed_users = 2;
     */
    allowedUsers;
    /**
     * @generated from field: no.jotta.openapi.Storage current_storage = 3;
     */
    currentStorage;
    /**
     * @generated from field: no.jotta.openapi.Storage current_allowed_storage = 4;
     */
    currentAllowedStorage;
    /**
     * @generated from field: optional no.jotta.openapi.offer.v1.Offer.CurrentSubscription.ContactSupport contact_support = 5;
     */
    contactSupport;
    /**
     * @generated from field: optional no.jotta.openapi.offer.v1.Offer.CurrentSubscription.BandwidthNotice bandwidth_notice = 6;
     */
    bandwidthNotice;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.offer.v1.Offer.CurrentSubscription";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "current_users", kind: "message", T: UserSeats },
        { no: 2, name: "allowed_users", kind: "message", T: UserSeats },
        { no: 3, name: "current_storage", kind: "message", T: Storage },
        { no: 4, name: "current_allowed_storage", kind: "message", T: Storage },
        { no: 5, name: "contact_support", kind: "message", T: Offer_CurrentSubscription_ContactSupport, opt: true },
        { no: 6, name: "bandwidth_notice", kind: "message", T: Offer_CurrentSubscription_BandwidthNotice, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new Offer_CurrentSubscription().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Offer_CurrentSubscription().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Offer_CurrentSubscription().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Offer_CurrentSubscription, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.offer.v1.Offer.CurrentSubscription.ContactSupport
 */
export class Offer_CurrentSubscription_ContactSupport extends Message {
    /**
     * "Need more space?", "Need more speed?" etc.
     *
     * @generated from field: string title_localized = 1;
     */
    titleLocalized = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.offer.v1.Offer.CurrentSubscription.ContactSupport";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "title_localized", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new Offer_CurrentSubscription_ContactSupport().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Offer_CurrentSubscription_ContactSupport().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Offer_CurrentSubscription_ContactSupport().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Offer_CurrentSubscription_ContactSupport, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.offer.v1.Offer.CurrentSubscription.BandwidthNotice
 */
export class Offer_CurrentSubscription_BandwidthNotice extends Message {
    /**
     * @generated from field: string localized_text = 1;
     */
    localizedText = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.offer.v1.Offer.CurrentSubscription.BandwidthNotice";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "localized_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new Offer_CurrentSubscription_BandwidthNotice().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Offer_CurrentSubscription_BandwidthNotice().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Offer_CurrentSubscription_BandwidthNotice().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Offer_CurrentSubscription_BandwidthNotice, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.offer.v1.Offer.BusinessUserNotPermitted
 */
export class Offer_BusinessUserNotPermitted extends Message {
    /**
     * @generated from field: repeated string business_admin_emails = 1;
     */
    businessAdminEmails = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.offer.v1.Offer.BusinessUserNotPermitted";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "business_admin_emails", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new Offer_BusinessUserNotPermitted().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Offer_BusinessUserNotPermitted().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Offer_BusinessUserNotPermitted().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Offer_BusinessUserNotPermitted, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.offer.v1.UnauthenticatedOfferParams
 */
export class UnauthenticatedOfferParams extends Message {
    /**
     * @generated from field: string customer_group_code = 1;
     */
    customerGroupCode = "";
    /**
     * @generated from field: no.jotta.openapi.Country country = 2;
     */
    country = Country.UNKNOWN_COUNTRY;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.offer.v1.UnauthenticatedOfferParams";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "customer_group_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "country", kind: "enum", T: proto3.getEnumType(Country) },
    ]);
    static fromBinary(bytes, options) {
        return new UnauthenticatedOfferParams().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnauthenticatedOfferParams().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnauthenticatedOfferParams().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnauthenticatedOfferParams, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.offer.v1.GetOfferRequest
 */
export class GetOfferRequest extends Message {
    /**
     * @generated from field: string product_code = 1;
     */
    productCode = "";
    /**
     * @generated from field: optional no.jotta.openapi.offer.v1.UnauthenticatedOfferParams unauthenticated_params = 2;
     */
    unauthenticatedParams;
    /**
     * @generated from field: optional uint32 extra_storage_tb = 3;
     */
    extraStorageTb;
    /**
     * @generated from field: optional uint32 extra_seats = 5;
     */
    extraSeats;
    /**
     * @generated from field: optional no.jotta.openapi.Language language = 4;
     */
    language;
    /**
     * @generated from field: optional string voucher_code = 6;
     */
    voucherCode;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.offer.v1.GetOfferRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "product_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "unauthenticated_params", kind: "message", T: UnauthenticatedOfferParams, opt: true },
        { no: 3, name: "extra_storage_tb", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
        { no: 5, name: "extra_seats", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
        { no: 4, name: "language", kind: "enum", T: proto3.getEnumType(Language), opt: true },
        { no: 6, name: "voucher_code", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new GetOfferRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOfferRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOfferRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOfferRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.offer.v1.GetOfferResponse
 */
export class GetOfferResponse extends Message {
    /**
     * @generated from field: no.jotta.openapi.offer.v1.Offer offer = 1;
     */
    offer;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.offer.v1.GetOfferResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "offer", kind: "message", T: Offer },
    ]);
    static fromBinary(bytes, options) {
        return new GetOfferResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOfferResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOfferResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOfferResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.offer.v1.GetOffersRequest
 */
export class GetOffersRequest extends Message {
    /**
     * @generated from field: optional no.jotta.openapi.offer.v1.UnauthenticatedOfferParams unauthenticated_params = 1;
     */
    unauthenticatedParams;
    /**
     * @generated from field: optional no.jotta.openapi.Language language = 2;
     */
    language;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.offer.v1.GetOffersRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "unauthenticated_params", kind: "message", T: UnauthenticatedOfferParams, opt: true },
        { no: 2, name: "language", kind: "enum", T: proto3.getEnumType(Language), opt: true },
    ]);
    static fromBinary(bytes, options) {
        return new GetOffersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOffersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOffersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOffersRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.offer.v1.GetOffersResponse
 */
export class GetOffersResponse extends Message {
    /**
     * @generated from field: repeated no.jotta.openapi.offer.v1.GetOffersResponse.Category categories = 1;
     */
    categories = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.offer.v1.GetOffersResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "categories", kind: "message", T: GetOffersResponse_Category, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new GetOffersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOffersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOffersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOffersResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.offer.v1.GetOffersResponse.Category
 */
export class GetOffersResponse_Category extends Message {
    /**
     * @generated from field: string name_localized = 1;
     */
    nameLocalized = "";
    /**
     * @generated from field: repeated no.jotta.openapi.offer.v1.Offer offers = 2;
     */
    offers = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.offer.v1.GetOffersResponse.Category";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "name_localized", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "offers", kind: "message", T: Offer, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new GetOffersResponse_Category().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOffersResponse_Category().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOffersResponse_Category().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOffersResponse_Category, a, b);
    }
}
